import { ref } from 'vue'
import { useRegisterSW } from 'virtual:pwa-register/vue'

/**
 * Composable for managing app version and updates
 *
 * This composable:
 * 1. Registers the service worker and listens for updates
 * 2. Provides a manual update function for user-initiated updates
 * 3. Shows update availability without forcing reload
 */
export function useAppVersion() {
  const currentVersion = ref(import.meta.env.VITE_APP_VERSION || '1.0.0')

  // Register service worker
  const { needRefresh, offlineReady, updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      console.log('[App Version] Service Worker registered:', swUrl)

      // Check for updates every 30 minutes (less aggressive)
      if (registration) {
        setInterval(
          () => {
            console.log('[App Version] Checking for updates...')
            registration.update()
          },
          30 * 60 * 1000
        ) // 30 minutes
      }
    },
    onRegisterError(error) {
      console.error('[App Version] Service Worker registration error:', error)
    }
  })

  /**
   * Reload the application to apply updates
   * Called when user clicks the update button
   */
  const updateApp = async () => {
    console.log('[App Version] User initiated update')
    await updateServiceWorker(true)
  }

  return {
    currentVersion,
    needRefresh,
    offlineReady,
    updateApp
  }
}
